import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'info'

export const useToastStore = defineStore('toast', () => {
  const message = ref('')
  const type = ref<ToastType>('success')
  const visible = ref(false)
  let hideTimer: ReturnType<typeof setTimeout> | null = null

  function show(text: string, toastType: ToastType = 'success', durationMs = 3500) {
    if (hideTimer) clearTimeout(hideTimer)
    message.value = text
    type.value = toastType
    visible.value = true
    hideTimer = setTimeout(() => {
      visible.value = false
      hideTimer = null
    }, durationMs)
  }

  function success(text: string) {
    show(text, 'success')
  }

  function error(text: string) {
    show(text, 'error', 5000)
  }

  function dismiss() {
    if (hideTimer) clearTimeout(hideTimer)
    hideTimer = null
    visible.value = false
  }

  return { message, type, visible, show, success, error, dismiss }
})
